module.exports = __webpack_public_path__ + "static/media/icono_lupulo.dff5787c.svg";